var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',{attrs:{"fluid":""}},[_c('NavBar',{ref:"navbar",on:{"show-login":_vm.showLogin,"show-dashboard":_vm.showDashboard,"event":_vm.navbarEvent}}),_c('router-view',{ref:"view",on:{"load-application":_vm.loadApplication,"show-login":_vm.showLogin,"show-dashboard":_vm.showDashboard}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }